import React from "react";
import { Toast } from "../../components/ui/Toast/Toast";
import EmailForm from "./components/EmailForm";
import PasswordForm from "./components/PasswordForm";

const UserAccountPage = () => {
    return (
        <>
            <Toast/>
            <div className="pl-20 pr-8 mt-8">
                <p style={{fontFamily: 'DIN condensed'}} className="mt-10 mb-6 text-4xl ">Mon compte</p>

                <EmailForm/>
                <PasswordForm/>
            </div>
        </>
    )
}

export default UserAccountPage;